var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag-edit"},[_c('el-tag',_vm._b({},'el-tag',_vm.$attrs,false),[_vm._t("default")],2),(_vm.msg)?_c('p',{staticClass:"el-tag--danger"},[_vm._v(_vm._s(_vm.msg))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }